export default "__VITE_ASSET__DyNn_QOC__"